import parse from 'utils/parse';
import settings from 'configurations/application/config';
import ff from 'services/feature-toggle';

const makeTestId = (...ids: string[]): string => parse.toTestId('shared', 'app-header-controls', ...ids);

const testId = Object.freeze({
  container: makeTestId(),
  languageSelector: makeTestId('language-selector'),
});

const langCodes = settings.i18n.languages.filter((lang) => lang !== 'hi' || ff.enabled('enableHindi'));

export { testId, langCodes };
